import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import * as moment from "moment";
import { Addition } from "../models/addition.model";
import { MomentFormatterService } from "src/app/shared/helpers/datetime/moment-formatter.service";

@Injectable({
    providedIn: "root"
  })

export class AdditionsService extends ApiBaseService {
    constructor(private configService: ConfigService, private http: HttpClient, private us: UserService, private momentFormatter: MomentFormatterService) {
      super(us);
      this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-project-key', }) };
      this.baseUrl = `${this.configService.config.projectUrl}/api/addition`;
    }

    getNotConnectedToTimeWithinPeriod(fromDate: moment.Moment, toDate: moment.Moment, projectReadAll: boolean): Observable<Addition[]> {
      const request = {
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate),
        "HasReadAllPermission": projectReadAll
      };

      return this.http.post<Addition[]>(`${this.baseUrl}/getnotconnectedtotimewithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Addition[]> {
      const request = {
        "ProjectId": id,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<Addition[]>(`${this.baseUrl}/getbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getApprovedByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Addition[]> {
      const request = {
        "ProjectId": id,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<Addition[]>(`${this.baseUrl}/getapprovedbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getByTimeEmployeeWithinPeriod(timeId: number, employeeId: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Addition[]> {
      const request = {
        "TimeId": timeId,
        "EmployeeId": employeeId,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<Addition[]>(`${this.baseUrl}/getbytimeandemployeewithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getByTime(id: number): Observable<Addition[]> {
      return this.http.get<Addition[]>(`${this.baseUrl}/getbytimeid?timeId=${id}`, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    updateAddition(addition: Addition) {
      return this.http.post(`${this.baseUrl}/updateAddition`, addition, this.httpOptions)
      .pipe(catchError(this.handleError<any>(`Failed to update addition`)));
    }

    addAddition(addition: Addition) {
      return this.http.post(`${this.baseUrl}/addAddition`, addition, this.httpOptions)
      .pipe(catchError(this.handleError<any>(`Failed to add addition`)));
    }

    getAdditionTypes() {
      return this.http.get<any>(this.baseUrl + "/GetAdditionTypes", this.httpOptions);
    }

    saveMultipleAdditions(additionsToAdd: any[], additionsToUpdate: any[]): Observable<any> {
      var additions = {
        AdditionsToAdd: additionsToAdd,
        AdditionsToUpdate: additionsToUpdate
      };
      return this.http.post<any>(this.baseUrl + '/AdditionSaveMultipleTimes', additions, this.httpOptions);
    }

    deleteByAdditionIds(ids: number[]): Observable<any> {
      return this.http.post<any>(`${this.baseUrl}/deleteAdditionByAdditionIds`, ids, this.httpOptions);
    }
}
